import '@tarojs/plugin-platform-h5/dist/runtime'

import { initPxTransform } from '@tarojs/taro'
import { createRouter } from '@tarojs/router'
import component from "./app"
import { window } from '@tarojs/runtime'
import { createReactApp } from '@tarojs/plugin-framework-react/dist/runtime'

import * as React from 'react'
import ReactDOM from 'react-dom/client'

import { findDOMNode, render, unstable_batchedUpdates } from 'react-dom'
import { defineCustomElementTaroPullToRefresh } from '@tarojs/components/dist/components'


var config = {"router":{"mode":"browser"},"pages":["/pages/home/index","/pages/home/search","/pages/home/searchResult","/pages/home/daily","/pages/home/activity","/pages/home/activityOld","/pages/home/mainActivity","/pages/home/dailyActivity","/pages/home/preview","/pages/home/rankGvm","/pages/home/potOfGold","/pages/home/L2","/pages/home/SY","/pages/home/SYLO","/pages/home/SYLX","/pages/home/YCSR","/pages/home/SYN","/pages/home/GMV","/pages/home/youpikGMV","/pages/youpikker/index","/pages/mine/index","/pages/mine/setting","/pages/item/detail","/pages/item/noItem","/pages/item/commentList","/pages/order/confirm","/pages/order/detail","/pages/order/payCode","/pages/order/cancel","/pages/order/list","/pages/order/expressDetail","/pages/order/payConfirm","/pages/order/result","/pages/order/promptpay/index","/pages/return/myReturns","/pages/return/myCancel","/pages/return/request","/pages/return/requestTwo","/pages/return/bank","/pages/address/list","/pages/address/manage","/pages/store/store","/pages/share/shareVip","/pages/share/shareFans","/pages/share/batchShare","/pages/login/login","/pages/login/forgot","/pages/login/setPassword","/pages/login/bindMember","/pages/login/callBack","/pages/login/pdfh5","/pages/login/setNewPassword","/pages/login/getApp","/pages/login/callBack","/pages/login/pdfh5","/pages/login/signupSuccess","/pages/help/center","/pages/help/orders","/pages/help/delivery","/pages/help/payment","/pages/help/child","/pages/help/live","/pages/appDowload/index","/pages/youpikker/notice","/pages/youpikker/share","/pages/youpikker/shareTwo","/pages/youpikker/memberships","/pages/activity/activity","/pages/activity/endOfMonth","/pages/activity/doubleTen","/pages/activity/doubleTwe","/pages/activity/venue/index","/pages/activity/main","/pages/home/activityPre","/pages/activity/venue/indexNoCoupon","/pages/activity/venue/catike","/pages/activity/venue/weyon","/pages/activity/venue/44","/pages/activity/venue/55plus","/pages/activity/venue/410","/pages/activity/venue/household","/pages/activity/venue/ecotec","/pages/activity/venue/418","/pages/activity/venue/425","/pages/activity/venue/421","/pages/activity/venue/51","/pages/activity/venue/52music","/pages/activity/venue/52liven","/pages/activity/venue/55","/pages/activity/venue/511","/pages/activity/venue/516","/pages/activity/venue/516catike","/pages/activity/venue/516hoopet","/pages/return/cancelResult","/pages/return/cancelDetail","/pages/return/returnDetail","/pages/return/refundDetail","/pages/return/expressInfo","/pages/iframe/index","/pages/lazadaVoucher/index","/pages/lazadaAdsense/index","/pages/lazadaAdsense/item","/pages/lazadaAdsense/jump","/pages/lazadaAdsense/introduction","/pages/lazadaAdsense/dailyPush","/pages/lazadaAdsense/highCom","/pages/lazadaAdsense/help","/pages/lazadaAdsense/recharge","/pages/customerService/index","/pages/share/becomeYoupikker","/pages/protocol/termOfUse","/pages/protocol/privacyPolicy","/pages/home/activityRule","/pages/couponProduct/item","/pages/couponProduct/confirm","/pages/lazadaAdsense/tempIntroduce","/pages/pdf/index","/pages/lazadaAdsense/activity","/pages/faq/index","/pages/rank/index","/pages/rank/secondLevel","/pages/tiktok/index","/pages/tiktok/collection","/pages/tiktok/PDP/index","/pages/tiktok/searchPage","/pages/tiktok/searchResult","/pages/tiktok/guide","/pages/tiktok/PDP","/pages/activity/placeOrder","/pages/share450/index","/pages/tiktok/authorize","/pages/tiktok/authorize/authing","/pages/tiktok/authorize/debug","/pages/tiktok/authorize/debug/hayley","/pages/tiktokLogin/login","/pages/tiktokLogin/bindMember","/pages/tiktokLogin/forgot","/pages/tiktokLogin/setNewPassword","/pages/tiktokLogin/setPassword","/pages/tiktokLogin/signupSuccess","/pages/transfer/index","/pages/uchoiceDownload/index","/pages/tiktok/rank","/pages/top3products/index","/pages/landing/hot","/pages/top3products/index2","/pages/tiktok/landing/index","/pages/top3products/index3","/pages/tools/index","/pages/tools/views/BioEditDetail/index","/pages/tools/views/GalleryEditDetail/index","/pages/tools/views/GalleryEditDetail/ImgDetail/index","/pages/tools/views/LazadaEditDetail/index","/pages/tools/views/DonateEditDetail/index","/pages/tools/views/GlobalSetting/index","/pages/tools/views/PersonalSetting/index","/pages/tools/views/PreviewPage/index","/pages/tools/views/ProductEditDetail/index","/pages/tools/views/ProductImport/index","/pages/tools/views/QuickAddProduct/index","/pages/tools/views/TemplateSetting/index","/pages/tiktok/selection","/pages/tools/views/GuideHome/index","/pages/tools/views/TemplateList/index","/pages/tools/views/GuideWhat/index","/pages/tools/views/GuideManual/index","/pages/tools/views/GuidePdf/index","/pages/download/guide/index","/pages/uchoice/download/index","/pages/uchoice/download/tiktok"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"Youpik","navigationBarTextStyle":"black"},"animation":{"duration":250,"delay":0}}
window.__taroAppConfig = config

if (config.tabBar) {
  var tabbarList = config.tabBar.list
  for (var i = 0; i < tabbarList.length; i++) {
    var t = tabbarList[i]
    if (t.iconPath) {
      t.iconPath = tabbarIconPath[i]
    }
    if (t.selectedIconPath) {
      t.selectedIconPath = tabbarSelectedIconPath[i]
    }
  }
}
config.routes = [
  Object.assign({
  path: '/pages/home/index',
  load: function(context, params) {
    const page = import("./pages/home/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Home"}),Object.assign({
  path: '/pages/home/search',
  load: function(context, params) {
    const page = import("./pages/home/search")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Search"}),Object.assign({
  path: '/pages/home/searchResult',
  load: function(context, params) {
    const page = import("./pages/home/searchResult")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SearchResult"}),Object.assign({
  path: '/pages/home/daily',
  load: function(context, params) {
    const page = import("./pages/home/daily")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Daily"}),Object.assign({
  path: '/pages/home/activity',
  load: function(context, params) {
    const page = import("./pages/home/activity")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/home/activityOld',
  load: function(context, params) {
    const page = import("./pages/home/activityOld")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/home/mainActivity',
  load: function(context, params) {
    const page = import("./pages/home/mainActivity")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Main Activity"}),Object.assign({
  path: '/pages/home/dailyActivity',
  load: function(context, params) {
    const page = import("./pages/home/dailyActivity")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Daily Activity"}),Object.assign({
  path: '/pages/home/preview',
  load: function(context, params) {
    const page = import("./pages/home/preview")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/home/rankGvm',
  load: function(context, params) {
    const page = import("./pages/home/rankGvm")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"RankGvm"}),Object.assign({
  path: '/pages/home/potOfGold',
  load: function(context, params) {
    const page = import("./pages/home/potOfGold")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"PotOfGold"}),Object.assign({
  path: '/pages/home/L2',
  load: function(context, params) {
    const page = import("./pages/home/L2")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"L2"}),Object.assign({
  path: '/pages/home/SY',
  load: function(context, params) {
    const page = import("./pages/home/SY")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SSF"}),Object.assign({
  path: '/pages/home/SYLO',
  load: function(context, params) {
    const page = import("./pages/home/SYLO")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SYLO"}),Object.assign({
  path: '/pages/home/SYLX',
  load: function(context, params) {
    const page = import("./pages/home/SYLX")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SYLX"}),Object.assign({
  path: '/pages/home/YCSR',
  load: function(context, params) {
    const page = import("./pages/home/YCSR")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"YCSR"}),Object.assign({
  path: '/pages/home/SYN',
  load: function(context, params) {
    const page = import("./pages/home/SYN")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SYN"}),Object.assign({
  path: '/pages/home/GMV',
  load: function(context, params) {
    const page = import("./pages/home/GMV")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"YOUPIK CHOICE"}),Object.assign({
  path: '/pages/home/youpikGMV',
  load: function(context, params) {
    const page = import("./pages/home/youpikGMV")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpik Choice Sale Rewards"}),Object.assign({
  path: '/pages/youpikker/index',
  load: function(context, params) {
    const page = import("./pages/youpikker/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpiker"}),Object.assign({
  path: '/pages/mine/index',
  load: function(context, params) {
    const page = import("./pages/mine/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Account"}),Object.assign({
  path: '/pages/mine/setting',
  load: function(context, params) {
    const page = import("./pages/mine/setting")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Setting"}),Object.assign({
  path: '/pages/item/detail',
  load: function(context, params) {
    const page = import("./pages/item/detail")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Detail"}),Object.assign({
  path: '/pages/item/noItem',
  load: function(context, params) {
    const page = import("./pages/item/noItem")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"No Item"}),Object.assign({
  path: '/pages/item/commentList',
  load: function(context, params) {
    const page = import("./pages/item/commentList")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"comment"}),Object.assign({
  path: '/pages/order/confirm',
  load: function(context, params) {
    const page = import("./pages/order/confirm")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Confirm"}),Object.assign({
  path: '/pages/order/detail',
  load: function(context, params) {
    const page = import("./pages/order/detail")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Detail"}),Object.assign({
  path: '/pages/order/payCode',
  load: function(context, params) {
    const page = import("./pages/order/payCode")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Select Payment Method"}),Object.assign({
  path: '/pages/order/cancel',
  load: function(context, params) {
    const page = import("./pages/order/cancel")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Cancellation Request"}),Object.assign({
  path: '/pages/order/list',
  load: function(context, params) {
    const page = import("./pages/order/list")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"OrderList"}),Object.assign({
  path: '/pages/order/expressDetail',
  load: function(context, params) {
    const page = import("./pages/order/expressDetail")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Order Details"}),Object.assign({
  path: '/pages/order/payConfirm',
  load: function(context, params) {
    const page = import("./pages/order/payConfirm")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Pay Confirm"}),Object.assign({
  path: '/pages/order/result',
  load: function(context, params) {
    const page = import("./pages/order/result")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Pay Result"}),Object.assign({
  path: '/pages/order/promptpay/index',
  load: function(context, params) {
    const page = import("./pages/order/promptpay/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"PromptPay"}),Object.assign({
  path: '/pages/return/myReturns',
  load: function(context, params) {
    const page = import("./pages/return/myReturns")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"My Returns"}),Object.assign({
  path: '/pages/return/myCancel',
  load: function(context, params) {
    const page = import("./pages/return/myCancel")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"My Cancel"}),Object.assign({
  path: '/pages/return/request',
  load: function(context, params) {
    const page = import("./pages/return/request")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Return Request"}),Object.assign({
  path: '/pages/return/requestTwo',
  load: function(context, params) {
    const page = import("./pages/return/requestTwo")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Return Request"}),Object.assign({
  path: '/pages/return/bank',
  load: function(context, params) {
    const page = import("./pages/return/bank")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Bank Transfer"}),Object.assign({
  path: '/pages/address/list',
  load: function(context, params) {
    const page = import("./pages/address/list")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Address List"}),Object.assign({
  path: '/pages/address/manage',
  load: function(context, params) {
    const page = import("./pages/address/manage")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Address Manage"}),Object.assign({
  path: '/pages/store/store',
  load: function(context, params) {
    const page = import("./pages/store/store")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Store"}),Object.assign({
  path: '/pages/share/shareVip',
  load: function(context, params) {
    const page = import("./pages/share/shareVip")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Become VIP Member"}),Object.assign({
  path: '/pages/share/shareFans',
  load: function(context, params) {
    const page = import("./pages/share/shareFans")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Special For You - Shop Now! "}),Object.assign({
  path: '/pages/share/batchShare',
  load: function(context, params) {
    const page = import("./pages/share/batchShare")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/login/login',
  load: function(context, params) {
    const page = import("./pages/login/login")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Login"}),Object.assign({
  path: '/pages/login/forgot',
  load: function(context, params) {
    const page = import("./pages/login/forgot")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Forgot"}),Object.assign({
  path: '/pages/login/setPassword',
  load: function(context, params) {
    const page = import("./pages/login/setPassword")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Set Password"}),Object.assign({
  path: '/pages/login/bindMember',
  load: function(context, params) {
    const page = import("./pages/login/bindMember")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Bind Member"}),Object.assign({
  path: '/pages/login/callBack',
  load: function(context, params) {
    const page = import("./pages/login/callBack")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Call Back"}),Object.assign({
  path: '/pages/login/pdfh5',
  load: function(context, params) {
    const page = import("./pages/login/pdfh5")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/login/setNewPassword',
  load: function(context, params) {
    const page = import("./pages/login/setNewPassword")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Set NewPassword"}),Object.assign({
  path: '/pages/login/getApp',
  load: function(context, params) {
    const page = import("./pages/login/getApp")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Get App"}),Object.assign({
  path: '/pages/login/callBack',
  load: function(context, params) {
    const page = import("./pages/login/callBack")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Call Back"}),Object.assign({
  path: '/pages/login/pdfh5',
  load: function(context, params) {
    const page = import("./pages/login/pdfh5")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/login/signupSuccess',
  load: function(context, params) {
    const page = import("./pages/login/signupSuccess")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Signup Success"}),Object.assign({
  path: '/pages/help/center',
  load: function(context, params) {
    const page = import("./pages/help/center")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpik University"}),Object.assign({
  path: '/pages/help/orders',
  load: function(context, params) {
    const page = import("./pages/help/orders")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Help Center Orders"}),Object.assign({
  path: '/pages/help/delivery',
  load: function(context, params) {
    const page = import("./pages/help/delivery")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Help Center Shipping & Delivery"}),Object.assign({
  path: '/pages/help/payment',
  load: function(context, params) {
    const page = import("./pages/help/payment")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Help Center Payments"}),Object.assign({
  path: '/pages/help/child',
  load: function(context, params) {
    const page = import("./pages/help/child")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Help Center Child"}),Object.assign({
  path: '/pages/help/live',
  load: function(context, params) {
    const page = import("./pages/help/live")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Live"}),Object.assign({
  path: '/pages/appDowload/index',
  load: function(context, params) {
    const page = import("./pages/appDowload/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpik"}),Object.assign({
  path: '/pages/youpikker/notice',
  load: function(context, params) {
    const page = import("./pages/youpikker/notice")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Notice"}),Object.assign({
  path: '/pages/youpikker/share',
  load: function(context, params) {
    const page = import("./pages/youpikker/share")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpiker"}),Object.assign({
  path: '/pages/youpikker/shareTwo',
  load: function(context, params) {
    const page = import("./pages/youpikker/shareTwo")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpiker"}),Object.assign({
  path: '/pages/youpikker/memberships',
  load: function(context, params) {
    const page = import("./pages/youpikker/memberships")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Memberships"}),Object.assign({
  path: '/pages/activity/activity',
  load: function(context, params) {
    const page = import("./pages/activity/activity")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/activity/endOfMonth',
  load: function(context, params) {
    const page = import("./pages/activity/endOfMonth")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/activity/doubleTen',
  load: function(context, params) {
    const page = import("./pages/activity/doubleTen")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/activity/doubleTwe',
  load: function(context, params) {
    const page = import("./pages/activity/doubleTwe")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"1212"}),Object.assign({
  path: '/pages/activity/venue/index',
  load: function(context, params) {
    const page = import("./pages/activity/venue/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"主会场"}),Object.assign({
  path: '/pages/activity/main',
  load: function(context, params) {
    const page = import("./pages/activity/main")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Main Activity"}),Object.assign({
  path: '/pages/home/activityPre',
  load: function(context, params) {
    const page = import("./pages/home/activityPre")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Activity"}),Object.assign({
  path: '/pages/activity/venue/indexNoCoupon',
  load: function(context, params) {
    const page = import("./pages/activity/venue/indexNoCoupon")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"主会场"}),Object.assign({
  path: '/pages/activity/venue/catike',
  load: function(context, params) {
    const page = import("./pages/activity/venue/catike")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"catike"}),Object.assign({
  path: '/pages/activity/venue/weyon',
  load: function(context, params) {
    const page = import("./pages/activity/venue/weyon")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"WEYON"}),Object.assign({
  path: '/pages/activity/venue/44',
  load: function(context, params) {
    const page = import("./pages/activity/venue/44")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"4.4 DDay"}),Object.assign({
  path: '/pages/activity/venue/55plus',
  load: function(context, params) {
    const page = import("./pages/activity/venue/55plus")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Youpik Plus"}),Object.assign({
  path: '/pages/activity/venue/410',
  load: function(context, params) {
    const page = import("./pages/activity/venue/410")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ช้อปมันส์ แชร์สนั่นท้ายเดือน"}),Object.assign({
  path: '/pages/activity/venue/household',
  load: function(context, params) {
    const page = import("./pages/activity/venue/household")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ECOTEC  Brand Day"}),Object.assign({
  path: '/pages/activity/venue/ecotec',
  load: function(context, params) {
    const page = import("./pages/activity/venue/ecotec")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ECOTEC  Brand Day"}),Object.assign({
  path: '/pages/activity/venue/418',
  load: function(context, params) {
    const page = import("./pages/activity/venue/418")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"BestBuy_Youpik Brand Day"}),Object.assign({
  path: '/pages/activity/venue/425',
  load: function(context, params) {
    const page = import("./pages/activity/venue/425")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Bear Rich"}),Object.assign({
  path: '/pages/activity/venue/421',
  load: function(context, params) {
    const page = import("./pages/activity/venue/421")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ช้อปมันส์ แชร์สนั่นท้ายเดือน"}),Object.assign({
  path: '/pages/activity/venue/51',
  load: function(context, params) {
    const page = import("./pages/activity/venue/51")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Teasing Main Page"}),Object.assign({
  path: '/pages/activity/venue/52music',
  load: function(context, params) {
    const page = import("./pages/activity/venue/52music")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Musicplant_youpik Brand Day"}),Object.assign({
  path: '/pages/activity/venue/52liven',
  load: function(context, params) {
    const page = import("./pages/activity/venue/52liven")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"LIVEN Brand Day"}),Object.assign({
  path: '/pages/activity/venue/55',
  load: function(context, params) {
    const page = import("./pages/activity/venue/55")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"D-Day Main Page"}),Object.assign({
  path: '/pages/activity/venue/511',
  load: function(context, params) {
    const page = import("./pages/activity/venue/511")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Back To School"}),Object.assign({
  path: '/pages/activity/venue/516',
  load: function(context, params) {
    const page = import("./pages/activity/venue/516")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"UP LIFE TOP STORE Brand"}),Object.assign({
  path: '/pages/activity/venue/516catike',
  load: function(context, params) {
    const page = import("./pages/activity/venue/516catike")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Catike Store Day"}),Object.assign({
  path: '/pages/activity/venue/516hoopet',
  load: function(context, params) {
    const page = import("./pages/activity/venue/516hoopet")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Hoopet official store"}),Object.assign({
  path: '/pages/return/cancelResult',
  load: function(context, params) {
    const page = import("./pages/return/cancelResult")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Cancellation End Page"}),Object.assign({
  path: '/pages/return/cancelDetail',
  load: function(context, params) {
    const page = import("./pages/return/cancelDetail")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Cancellation Details"}),Object.assign({
  path: '/pages/return/returnDetail',
  load: function(context, params) {
    const page = import("./pages/return/returnDetail")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Return Details"}),Object.assign({
  path: '/pages/return/refundDetail',
  load: function(context, params) {
    const page = import("./pages/return/refundDetail")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Refund Detail"}),Object.assign({
  path: '/pages/return/expressInfo',
  load: function(context, params) {
    const page = import("./pages/return/expressInfo")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Express Type"}),Object.assign({
  path: '/pages/iframe/index',
  load: function(context, params) {
    const page = import("./pages/iframe/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"iframe"}),Object.assign({
  path: '/pages/lazadaVoucher/index',
  load: function(context, params) {
    const page = import("./pages/lazadaVoucher/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/lazadaAdsense/index',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"LazadaAdsense"}),Object.assign({
  path: '/pages/lazadaAdsense/item',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/item")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"LazadaAdsenseItem"}),Object.assign({
  path: '/pages/lazadaAdsense/jump',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/jump")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Jump Lazada"}),Object.assign({
  path: '/pages/lazadaAdsense/introduction',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/introduction")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"New version introduction"}),Object.assign({
  path: '/pages/lazadaAdsense/dailyPush',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/dailyPush")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"BEST DEALS"}),Object.assign({
  path: '/pages/lazadaAdsense/highCom',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/highCom")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"HIGH COMMISSION"}),Object.assign({
  path: '/pages/lazadaAdsense/help',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/help")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"LazadaAdsenseHelp"}),Object.assign({
  path: '/pages/lazadaAdsense/recharge',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/recharge")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"LazadaAdsenseRecharge"}),Object.assign({
  path: '/pages/customerService/index',
  load: function(context, params) {
    const page = import("./pages/customerService/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"CustomerService"}),Object.assign({
  path: '/pages/share/becomeYoupikker',
  load: function(context, params) {
    const page = import("./pages/share/becomeYoupikker")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"becomeYoupikker"}),Object.assign({
  path: '/pages/protocol/termOfUse',
  load: function(context, params) {
    const page = import("./pages/protocol/termOfUse")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"termOfUse"}),Object.assign({
  path: '/pages/protocol/privacyPolicy',
  load: function(context, params) {
    const page = import("./pages/protocol/privacyPolicy")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"privacyPolicy"}),Object.assign({
  path: '/pages/home/activityRule',
  load: function(context, params) {
    const page = import("./pages/home/activityRule")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ActivityRule"}),Object.assign({
  path: '/pages/couponProduct/item',
  load: function(context, params) {
    const page = import("./pages/couponProduct/item")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"CounponProductItem"}),Object.assign({
  path: '/pages/couponProduct/confirm',
  load: function(context, params) {
    const page = import("./pages/couponProduct/confirm")
    return [page, context, params]
  }
}, {"navigationBarTitleText":""}),Object.assign({
  path: '/pages/lazadaAdsense/tempIntroduce',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/tempIntroduce")
    return [page, context, params]
  }
}, {"navigationBarTitleText":""}),Object.assign({
  path: '/pages/pdf/index',
  load: function(context, params) {
    const page = import("./pages/pdf/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/lazadaAdsense/activity',
  load: function(context, params) {
    const page = import("./pages/lazadaAdsense/activity")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Jump Lazada"}),Object.assign({
  path: '/pages/faq/index',
  load: function(context, params) {
    const page = import("./pages/faq/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"FAQ"}),Object.assign({
  path: '/pages/rank/index',
  load: function(context, params) {
    const page = import("./pages/rank/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"index"}),Object.assign({
  path: '/pages/rank/secondLevel',
  load: function(context, params) {
    const page = import("./pages/rank/secondLevel")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"secondLevel"}),Object.assign({
  path: '/pages/tiktok/index',
  load: function(context, params) {
    const page = import("./pages/tiktok/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"tiktokHome"}),Object.assign({
  path: '/pages/tiktok/collection',
  load: function(context, params) {
    const page = import("./pages/tiktok/collection")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"My collection"}),Object.assign({
  path: '/pages/tiktok/PDP/index',
  load: function(context, params) {
    const page = import("./pages/tiktok/PDP/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tiktok/searchPage',
  load: function(context, params) {
    const page = import("./pages/tiktok/searchPage")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"tiktokSearch"}),Object.assign({
  path: '/pages/tiktok/searchResult',
  load: function(context, params) {
    const page = import("./pages/tiktok/searchResult")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"tiktokSearchResult"}),Object.assign({
  path: '/pages/tiktok/guide',
  load: function(context, params) {
    const page = import("./pages/tiktok/guide")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"What is Uchoice & Tiktok?&TikTok?"}),Object.assign({
  path: '/pages/tiktok/PDP',
  load: function(context, params) {
    const page = import("./pages/tiktok/PDP")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/activity/placeOrder',
  load: function(context, params) {
    const page = import("./pages/activity/placeOrder")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"First Order Reward"}),Object.assign({
  path: '/pages/share450/index',
  load: function(context, params) {
    const page = import("./pages/share450/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tiktok/authorize',
  load: function(context, params) {
    const page = import("./pages/tiktok/authorize")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tiktok Authorize"}),Object.assign({
  path: '/pages/tiktok/authorize/authing',
  load: function(context, params) {
    const page = import("./pages/tiktok/authorize/authing")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tiktok Authing"}),Object.assign({
  path: '/pages/tiktok/authorize/debug',
  load: function(context, params) {
    const page = import("./pages/tiktok/authorize/debug")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tiktok Debug"}),Object.assign({
  path: '/pages/tiktok/authorize/debug/hayley',
  load: function(context, params) {
    const page = import("./pages/tiktok/authorize/debug/hayley")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tiktok Debug"}),Object.assign({
  path: '/pages/tiktokLogin/login',
  load: function(context, params) {
    const page = import("./pages/tiktokLogin/login")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Login"}),Object.assign({
  path: '/pages/tiktokLogin/bindMember',
  load: function(context, params) {
    const page = import("./pages/tiktokLogin/bindMember")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Bind Member"}),Object.assign({
  path: '/pages/tiktokLogin/forgot',
  load: function(context, params) {
    const page = import("./pages/tiktokLogin/forgot")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Forgot"}),Object.assign({
  path: '/pages/tiktokLogin/setNewPassword',
  load: function(context, params) {
    const page = import("./pages/tiktokLogin/setNewPassword")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Set NewPassword"}),Object.assign({
  path: '/pages/tiktokLogin/setPassword',
  load: function(context, params) {
    const page = import("./pages/tiktokLogin/setPassword")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Set Password"}),Object.assign({
  path: '/pages/tiktokLogin/signupSuccess',
  load: function(context, params) {
    const page = import("./pages/tiktokLogin/signupSuccess")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Signup Success"}),Object.assign({
  path: '/pages/transfer/index',
  load: function(context, params) {
    const page = import("./pages/transfer/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/uchoiceDownload/index',
  load: function(context, params) {
    const page = import("./pages/uchoiceDownload/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"uChoice"}),Object.assign({
  path: '/pages/tiktok/rank',
  load: function(context, params) {
    const page = import("./pages/tiktok/rank")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/top3products/index',
  load: function(context, params) {
    const page = import("./pages/top3products/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/landing/hot',
  load: function(context, params) {
    const page = import("./pages/landing/hot")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/top3products/index2',
  load: function(context, params) {
    const page = import("./pages/top3products/index2")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tiktok/landing/index',
  load: function(context, params) {
    const page = import("./pages/tiktok/landing/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/top3products/index3',
  load: function(context, params) {
    const page = import("./pages/top3products/index3")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/index',
  load: function(context, params) {
    const page = import("./pages/tools/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/BioEditDetail/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/BioEditDetail/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GalleryEditDetail/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GalleryEditDetail/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GalleryEditDetail/ImgDetail/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GalleryEditDetail/ImgDetail/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/LazadaEditDetail/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/LazadaEditDetail/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/DonateEditDetail/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/DonateEditDetail/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GlobalSetting/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GlobalSetting/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/PersonalSetting/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/PersonalSetting/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/PreviewPage/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/PreviewPage/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/ProductEditDetail/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/ProductEditDetail/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/ProductImport/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/ProductImport/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/QuickAddProduct/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/QuickAddProduct/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/TemplateSetting/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/TemplateSetting/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tiktok/selection',
  load: function(context, params) {
    const page = import("./pages/tiktok/selection")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GuideHome/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GuideHome/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/TemplateList/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/TemplateList/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GuideWhat/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GuideWhat/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GuideManual/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GuideManual/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/tools/views/GuidePdf/index',
  load: function(context, params) {
    const page = import("./pages/tools/views/GuidePdf/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/download/guide/index',
  load: function(context, params) {
    const page = import("./pages/download/guide/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/uchoice/download/index',
  load: function(context, params) {
    const page = import("./pages/uchoice/download/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: '/pages/uchoice/download/tiktok',
  load: function(context, params) {
    const page = import("./pages/uchoice/download/tiktok")
    return [page, context, params]
  }
}, {})
]
Object.assign(ReactDOM, { findDOMNode, render, unstable_batchedUpdates })
defineCustomElementTaroPullToRefresh()

var inst = createReactApp(component, React, ReactDOM, config)
createRouter(inst, config, React)
initPxTransform({
  designWidth: 750,
  deviceRatio: {"640":1.17,"750":1,"828":0.905},
  baseFontSize: 20,
  unitPrecision: undefined,
  targetUnit: undefined
})
